import { pipe, times, identity, map } from 'ramda';

export const FEATURE_NAME = 'medicalHistory';
export const CURRENT = 'current';
export const MEDICATIONS = 'medications';

export const VALUE = 'value';
export const DESCRIPTION = 'description';
export const LIST = 'list';

export const ILLNESSES = 'illnesses';
export const ALLERGIES = 'allergies';
export const SURGERY = 'surgery';
export const HEART = 'heart';
export const UNDER_TREATMENT = 'underTreatment';
export const EYE_DROPS = 'eyeDrops';

export const FILES = 'files';

export const BLOOD_PRESSURE = 'bloodPressure';
export const DIABETES = 'diabetes';
export const DEMENTIA = 'dementia';
export const ASTHMA = 'asthma';
export const SMOKING = 'smoking';
export const ALCOHOL = 'alcohol';
export const COMMENT = 'comment';

export const SEARCHABLE_MEDIA_UPDATE = 'SEARCHABLE_MEDIA_UPDATE';

export const DRUGS = 'drugs';
export const DESIGNATION = 'designation';
export const QUANTITY = 'quantity';
export const EYE = 'eye';
export const LEFT = 'left';
export const RIGHT = 'right';
export const BOTH = 'both';
export const FREQUENCY = 'frequency';
export const DURATION = 'duration';
export const VALID_FROM = 'validFrom';
export const VALID_TO = 'validTo';
export const ADD_TO_PRESCRIPTION = 'addToPrescription';
export const RETAIN_AFTER_EXAMINATION = 'retainAfterExamination';

export const CARE_LEVEL = 'careLevel';
export const CARE_LEVELS = pipe(
  times(identity),
  map((id) => ({
    id: String(id),
    label: `Pflegestufe ${id}`,
  }))
)(13);

export const MEDICATION_EYE_OPTIONS = [
  { id: LEFT, label: 'Linkes Auge' },
  { id: RIGHT, label: 'Rechtes Auge' },
  { id: BOTH, label: 'Beide Augen' },
];
export const MEDICATION_FREQUENCY_OPTIONS = [
  { id: 'onceDaily', label: 'einmal täglich' },
  { id: 'twiceDaily', label: 'zweimal täglich' },
  { id: 'threeTimesDaily', label: 'dreimal täglich' },
  { id: 'fourTimesDaily', label: 'viermal täglich' },
  { id: 'asNeeded', label: 'bei Bedarf' },
  { id: 'atNight', label: 'zur Nacht' },
];
export const MEDICATION_DURATION_OPTIONS = [
  { id: 'oneWeek', label: '1 Woche' },
  { id: 'twoWeeks', label: '2 Wochen' },
  { id: 'oneMonth', label: '1 Monat' },
  { id: 'sixMonths', label: '6 Monate' },
  { id: 'oneYear', label: '1 Jahr' },
];
